<div class="d-flex align-items-center justify-content-center flex-column" style="height: 100vh">
  <!--begin::Content-->
  <p class="font-size-h3 text-dark font-weight-normal m-15" style="font-size: 2.5rem !important; text-align: center">
    Connexion réussie! Vous pouvez fermer cette page en toute sécurité
  </p>

  <button [routerLink]="['/dashboard']" class="btn btn-primary btn-fixed-height font-weight-bold">Revenir Au Dashboard</button>
  <!--end::Content-->
</div>
